export default  {"src":"/_next/static/image/public/images/directions-colour.d53603e1de9b8e4c07ca6c75bc96a056.svg","height":824,"width":661};